/* HALAL ICHIBA renewal — shared UI behaviours
   Delegated listeners so it works with AJAX-replaced content. */
(function () {
  'use strict';

  // --- Drawer (SP category menu) + Filter drawer toggles ---
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) {
      document.body.classList.add('drawer-open');
    }
    if (e.target.closest('[data-drawer-close]')) {
      document.body.classList.remove('drawer-open');
    }
    if (e.target.closest('[data-filter-open]')) {
      document.body.classList.add('filter-open');
    }
    if (e.target.closest('[data-filter-close]')) {
      document.body.classList.remove('filter-open');
    }
    // Grid / list view toggle on the PLP
    var v = e.target.closest('[data-view]');
    if (v) {
      document.querySelectorAll('[data-view]').forEach(function (b) {
        b.classList.toggle('is-active', b === v);
      });
      var results = document.getElementById('results');
      if (results) results.classList.toggle('is-list', v.dataset.view === 'list');
      try { localStorage.setItem('rnw-view', v.dataset.view); } catch (err) {}
    }
  });

  // Restore last-used view
  try {
    var saved = localStorage.getItem('rnw-view');
    if (saved === 'list') {
      var r = document.getElementById('results');
      if (r) r.classList.add('is-list');
      document.querySelectorAll('[data-view]').forEach(function (b) {
        b.classList.toggle('is-active', b.dataset.view === 'list');
      });
    }
  } catch (err) {}

  // Close drawers on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.body.classList.remove('drawer-open', 'filter-open');
    }
  });

  // --- Filter form auto-submit (checkbox facets + sort select) ---
  document.addEventListener('change', function (e) {
    // Filter fields are attached with form="…" (the filter form wraps nothing).
    var form = e.target.form || e.target.closest('[data-filter-form]');
    if (!form || !form.hasAttribute('data-filter-form')) return;
    var t = e.target;
    // Price inputs wait for the explicit apply button; everything else submits.
    if (t.type === 'number') return;
    if (t.matches('input[type="checkbox"], input[type="radio"], select')) {
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
    }
  });

  // --- Quantity stepper (product page) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    // Respect the variant's quantity rule (min / increment / max) rendered on the input.
    var dir = parseInt(btn.dataset.qtyStep, 10) < 0 ? -1 : 1;
    var step = parseInt(input.step, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || Infinity;
    var val = (parseInt(input.value, 10) || min) + dir * step;
    val = min + Math.round((val - min) / step) * step;
    input.value = Math.min(max, Math.max(min, val));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // --- Product gallery: thumb → main ---
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var full = thumb.getAttribute('data-full');
    if (main && full) {
      main.src = full;
      main.srcset = '';
    }
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });
})();

/* カテゴリのアコーディオン開閉（左カラム） */
document.addEventListener('click', function (e) {
  var btn = e.target.closest ? e.target.closest('[data-fcat-toggle]') : null;
  if (!btn) return;
  e.preventDefault();
  var group = btn.closest('.fcat__group');
  if (!group) return;
  var sub = group.querySelector('.fcat__sub');
  var open = group.classList.toggle('is-open');
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (sub) sub.hidden = !open;
});
